<template>
  <ul class="disease-lists">
    <li
      class="item"
      v-for="item in diseaseLists"
      :key="item.itemid"
      @click="handleJumpDetails(item)"
    >
      <p class="title">
        <span class="name">{{ item.chname }}</span>
        <span :class="['right', item.levelClass]">{{ item.conclusion }}</span>
      </p>
      <p class="detail">
        <span>
          患病风险倍数：<span class="num">{{ item.risk }}</span>
        </span>
        <span class="right">
          终身患病风险：<span class="num">{{ item.rate }}%</span>
        </span>
      </p>
    </li>
  </ul>
</template>

<script>
export default {
  name: "DiseaseList",
  data() {
    return {};
  },
  props: {
    diseaseLists: {
      type: Array,
      default: () => [],
    },
    scode: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleJumpDetails(item) {
      this.$router.push({
        path: `/desease/details/${item.scode_type}/${this.scode}/${item.itemid}`,
      });
    },
  },
};
</script>

<style lang="scss">
.disease-lists {
  margin: 15px 0;
  .item {
    margin: 15px;
    padding: 10px;
    background-color: #fafafa;
    cursor: pointer;
    .title,
    .detail {
      display: flex;
      justify-content: space-between;
      .right{
        padding-right: .15rem;
      }
    }
    .title {
      font-size: 0.16rem;
      margin-bottom: 10px;
    }
    .detail {
      font-size: 0.14rem;
    }
    .detail .num {
      color: #007aff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/smallProduct/home/components/diseaseList.vue